import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ItemCollectNewIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M15.5 11.38H12.62V8.5C12.62 8.15 12.34 7.88 12 7.88C11.66 7.88 11.38 8.16 11.38 8.5V11.38H8.5C8.15 11.38 7.88 11.66 7.88 12C7.88 12.34 8.16 12.62 8.5 12.62H11.38V15.5C11.38 15.84 11.66 16.12 12 16.12C12.34 16.12 12.62 15.84 12.62 15.5V12.62H15.5C15.84 12.62 16.12 12.34 16.12 12C16.12 11.66 15.84 11.38 15.5 11.38Z"
        fill={color}
      />
      <path
        d="M19 0.25H5C3.48 0.25 2.25 1.48 2.25 3V21C2.25 22.52 3.48 23.75 5 23.75H19C20.52 23.75 21.75 22.52 21.75 21V3C21.75 1.48 20.52 0.25 19 0.25ZM20.25 21C20.25 21.69 19.69 22.25 19 22.25H5C4.31 22.25 3.75 21.69 3.75 21V3C3.75 2.31 4.31 1.75 5 1.75H19C19.69 1.75 20.25 2.31 20.25 3V21Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ItemCollectNewIcon.displayName = 'ItemCollectNewIcon';
